import Zoom from './Zoom'

export default Zoom
